import { render, staticRenderFns } from "./UsuarioAlterarSenha.vue?vue&type=template&id=7cb1ff24"
import script from "./UsuarioAlterarSenha.vue?vue&type=script&lang=js"
export * from "./UsuarioAlterarSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports